module.exports = __webpack_public_path__ + "static/media/toggle-up.cc6c571c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/toggle-up.svg
// module id = 945
// module chunks = 0